import Grid from "@visa/vds/grid";
import Row from "@visa/vds/row";
import { AdminRoutes } from "_constants/PageRoutes";
import { SubscriptionStatus } from "_constants/SubscriptionConstants";
import { PageHelper } from "_helpers/PageHelper";
import MCSHeader from "components/MCSHeader";
import MCSOverlayLoading from 'components/MCSOverlayLoading';
import ManageSubscriptionDisclaimer from "components/subscription/ManageSubscriptionDisclaimer";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import ErrorPage from "pages/Error/ErrorPage";
import React, { useContext, useEffect, useState } from "react";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { useHistory } from "react-router-dom";
import { SubscriptionApi } from "services/subscription.service";
import ManageSubscriptionTable from "./Components/ManageSubscriptionTable";
import { FileHelper } from "../../../_helpers/FileHelper";
import { useAuthContextUser } from "context/AuthContext";

const ManageSubscription = () => {
    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();
    const canExport = user && (user.isSuperAdmin || user.hasReportingExport);
    const history = useHistory();
    const { promiseInProgress } = usePromiseTracker();
    const [tableData, setTableData] = useState(null);
    const [totalPage, setTotalPage] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const PAGE_SIZE = 10;
    const sortBy = "organizationName"; const desc = false;
    const defaultFilter = {
        subscriptionStatus: SubscriptionStatus.Active
    };

    const handleClickAction = (s) => {
        history.push({
            pathname: AdminRoutes.MANAGESUBSCRIPTION_DETAILS,
            state: {
                subscriptionId: s.id,
            },
        });
    };

    const fetchData = async (page, sortBy, desc, filter, search) => {
        let skipCount = PageHelper.GetSkipCount(PAGE_SIZE, page);
        trackPromise(
            SubscriptionApi
                .AdminOrganizationGetOrganizationProductSubcriptionList(skipCount, sortBy, desc, filter, search)
                .then((response) => {
                    var result = response.data;
                    setTableData(result.items);
                    setTotalCount(result.totalCount);
                    setTotalPage(PageHelper.GetTotalCountToPages(PAGE_SIZE, result.totalCount));
                })
                .catch((error) => {
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    };

    const handleExportAll = async () => {
        trackPromise(
            SubscriptionApi
                .AdminExportAllOrganizationProductSubcriptions()
                .then((result) => {
                    FileHelper.DownloadFile(result);
                })
                .catch((error) => {
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    }

    useEffect(() => {
        fetchData(1, sortBy, desc, defaultFilter);
    }, []);

    return (
        <>
            {promiseInProgress && <MCSOverlayLoading></MCSOverlayLoading>}
            <GlobalAlertContext.Consumer>
                {() => (
                    <>
                        <Grid>
                            <MCSHeader header="Manage Subscriptions"/>
                            <ManageSubscriptionDisclaimer />
                            <Row>
                                <ManageSubscriptionTable
                                    fetchData={fetchData}
                                    enableExport={canExport} handleExportAll={handleExportAll}
                                    tableData={tableData} pageSize={PAGE_SIZE} totalCount={totalCount} totalPage={totalPage}
                                    defaultSortBy={sortBy} defaultDesc={desc} defaultFilter={defaultFilter}
                                    handleClickAction={handleClickAction}
                                />
                            </Row>
                        </Grid>
                    </>
                )}
            </GlobalAlertContext.Consumer>
        </>
    );
};
export default ManageSubscription;
